/**
* src/web/components/google-doc-dialog.jsx
*/
import React from 'react'
import { translate } from 'react-i18next'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import pdfPreviewTheme from './themes/pdf-preview.css'
import AppBar from 'react-toolbox/lib/app_bar'
import {
  Navigation,
} from 'react-toolbox/lib/navigation'
import rightSidePageAppBarTheme from './themes/right-side-page-app-bar.css'
import { GoogleLogin } from './google-signin-provider.jsx'
import config from '../../config'

  class GoogleDocDialog extends React.PureComponent {
    state = {
      googleLogin: false,
    }

		onGoogleSigninSuccess = ()=> this.setState({ googleLogin: true })
    closeDialog = ()=> this.props.closeDoc()

    render() {
      const {
        t,
        open,
        params,
        closeDoc,
      } = this.props

      return (
        <Dialog
          className={pdfPreviewTheme.docDialog}
          active={open}
          nEscKeyDown={this.closeDialog}
          onOverlayClick={this.closeDialog}>
          <AppBar flat title={t('label:Googleドキュメント')} theme={rightSidePageAppBarTheme}>
            <Navigation type='horizontal' style={{ whiteSpace: 'nowrap' }} >
              <IconButton icon='open_in_new' href={params} target='_blank' rel="noopener noreferrer" />
              <IconButton icon='close' onClick={this.closeDialog} />
            </Navigation>
          </AppBar>
          { !this.state.googleLogin &&
          	<GoogleLogin label={t('label:Googleドキュメントに接続')} onSuccess={this.onGoogleSigninSuccess} /> ||
            <iframe style={{border: '0px', width: '100%', height: 'calc(100vh - 120px)'}} src={params} />
          }
        </Dialog>
      )
    }
  }

  export default translate()(GoogleDocDialog)



// WEBPACK FOOTER //
// ./src/web/components/google-doc-dialog.jsx